import {LANDING_ROUTES} from '@/config/routes';

export const LEGAL_OPERATOR_NAME = 'AdvoTech';
export const LEGAL_CONTACT_EMAIL = 'kel.advotech@gmail.com';
export const LEGAL_GOVERNING_COUNTRY = 'Nepal';
export const LEGAL_LAST_UPDATED_AD = '2026-11-03';

export const legalLinks = [
  {href: LANDING_ROUTES.privacyPolicy, label: 'Privacy Policy'},
  {href: LANDING_ROUTES.termsAndConditions, label: 'Terms & Conditions'}
] as const;
